function minimumCharacterRule(minimum) {
  let minimumCharacterRule =  {
    test: ({
      password
    }) => {
      return {
        name: `At least ${minimum} characters long`,
        pass:  password.length >= minimum
      };
    }
  };

  return minimumCharacterRule;
}

export default minimumCharacterRule;